<template>
  <article
      class="ai-visibility-score-metric-card ai-visibility-score-metric-card--highlight"
  >
    <div class="ai-visibility-score-metric-card__title">
      <span>{{ title }}</span>
      <info-icon v-if="infoTitle" :info="{tooltip: infoTitle}"/>
    </div>
    <div class="ai-visibility-score-metric-card__value">
      <span>{{ value }}</span><span class="suffix">{{ suffix }}</span>
    </div>
    <progress-scale
        :value="numericValue"
        :max="max"
        :labels="scaleLabels"
    />
    <trend-badge
        v-if="trend"
        :direction="trend.direction"
        :tone="trend.tone"
        :label="trend.label"
    />
  </article>
</template>

<script>
import InfoIcon from '../display/InfoIcon.vue'
import ProgressScale from '../display/ProgressScale.vue'
import TrendBadge from '../display/TrendBadge.vue'

export default {
  name: 'ScoreMetricCard',
  components: {
    InfoIcon,
    ProgressScale,
    TrendBadge,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      required: true,
    },
    max: {
      type: Number,
      default: 100,
    },
    scaleLabels: {
      type: Array,
      default() {
        return []
      },
    },
    trend: {
      type: Object,
      default: null,
    },
    infoTitle: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: ' / 100'
    }
  },
  computed: {
    numericValue() {
      return Number(this.value) || 0
    }
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-score-metric-card {
  display: flex;
  min-height: 150px;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  border: 1px solid var(--v-gray13Color-base);
  border-radius: 8px;
  box-shadow: 0 5px 2px 0 rgba(0, 0, 0, 0.01), 0 3px 2px 0 rgba(0, 0, 0, 0.04), 0 1px 1px 0 rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.08);
  background: var(--v-cardBg-base);
  padding: 18px;
  justify-content: space-between;
}

.ai-visibility-score-metric-card--highlight {
  border: 1px solid var(--v-lightYellow1Color-base);
  background: linear-gradient(69deg, var(--v-whiteColor-base) 65.79%, var(--v-lightYellow2Color-base) 98.62%);
}

.ai-visibility-score-metric-card__title {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--v-mainGreen-base);
  font-weight: 500;

  span {
    font-size: 20px;
    line-height: 1.5;
  }
}

.ai-visibility-score-metric-card__value {
  color: var(--v-mainColor-base);
  font-weight: 700;
  line-height: 1.5;

  span {
    font-size: 36px;
  }

  span.suffix {
    font-size: 20px;
  }

}
</style>
